"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUniqueKey = void 0;
var lodash_1 = require("lodash");
var buildUniqueKey = function (name, params) {
    if (params === void 0) { params = {}; }
    if (!name) {
        throw Error('name must be defined');
    }
    return "".concat(name, "-").concat((0, lodash_1.sortBy)(Object.entries(params), function (_a) {
        var prop = _a[0];
        return prop;
    })
        .map(function (_a) {
        var prop = _a[0], value = _a[1];
        return "".concat(prop, ":").concat(value);
    })
        .join('-'));
};
exports.buildUniqueKey = buildUniqueKey;
//# sourceMappingURL=build-unique-key.js.map